import script from "./page-bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./page-bottom.vue?vue&type=script&setup=true&lang=js"

import "./page-bottom.vue?vue&type=style&index=0&id=0b7f0e58&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b7f0e58"]])

export default __exports__